import { render, staticRenderFns } from "./Subscribed.vue?vue&type=template&id=38d8d3e2"
import script from "./Subscribed.vue?vue&type=script&lang=js"
export * from "./Subscribed.vue?vue&type=script&lang=js"
import style0 from "./Subscribed.vue?vue&type=style&index=0&id=38d8d3e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports